// Copyright © 2019 David Caldwell <david@porkrind.org> All rights reserved.

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile,
                                in_suit_order=piles.in_suit_order, in_suit_wrap_order=piles.in_suit_wrap_order,
                                king=piles.king, ace=piles.ace,
                                up=piles.up, down=piles.down;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var options = require('./options'), option_def=options.option_def;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE, GAME_OVER=seed_game.GAME_OVER;
var prnt = require('./print'), sprintf=prnt.sprintf;

solitaire.crescent = class extends pile_game {
    constructor() {
        super();
        this.pile_game_init(...arguments);
        this.decks = 2;
        this.foundation = [...Array(8).keys()].map(i => new this.foundation_pile("foundation"+i, this, i<4 ? down : up));
        this.tableau = [...Array(16).keys()].map(i => new this.tableau_pile("tableau"+i, this));
    }
    valid_options = { redeals: option_def("number", 3, "Number of redeals allowed"),
                      undo:  option_def("boolean", true, "Allow undo past a redeal") };

    foundation_pile = class extends pile {
            constructor(div,game,dir) {
                super(div,game);
                this.dir=dir;
            }
        accept_stacks = false;
        accept(card) { return (this.dir == up   && in_suit_order(this.top(), card) ||
                               this.dir == down && in_suit_order(card, this.top())) ? 10 : 0; }
        xoffset = 0;
        yoffset = 0;
        can_drag(index) { return index != 0 && index == this.top_index(); }
    }

    tableau_pile = class extends pile {
        splice = pile.prototype.splice_and_turn_over;
        accept(card) { return this.pile.length && (in_suit_wrap_order(this.top(), card) ||
                                                   in_suit_wrap_order(card, this.top())) ? 4 : 0; }
        can_drag(index) { return index == this.top_index(); }
        xoffset = .5/90;
        yoffset = .5/131;
    }

    deal(deck) {
            this.update_redeals(this.options.redeals);
            var t=0;
            for (var c of deck) {
                if      (c.rank == king && this.foundation[  c.suit].pile.length == 0)
                    this.foundation[c.suit].push(c);
                else if (c.rank == ace  && this.foundation[4+c.suit].pile.length == 0)
                    this.foundation[4+c.suit].push(c);
                else
                    this.tableau[t++ % this.tableau.length].push(c);
            }
            for (let f of this.foundation)
                f.top().face = up;
            for (let t of this.tableau)
                t.top().face = up;

    }

    get_state() {
            var state = pile_game.prototype.get_state.call(this);
            state.redeals = this.redeals;
            return state;
    }

    set_state(old, noupdate) {
            pile_game.prototype.set_state.call(this, old, noupdate);
            this.update_redeals(old.redeals);
    }

    update_redeals(redeals) {
            this.shuffle_button.text(sprintf("Redeal (%d)", this.redeals = redeals));
            this.shuffle_button.enable(this.redeals > 0);
    }

    shuffle() {
            if (this.redeals <= 0)
                return;
            if (!this.options.undo)
                this.clear_state(); // disallow undo through a redeal
            else
                this.push_state(); // support undoing redeals
            this.update_redeals(this.redeals - 1);
            this.redeal();
    }

    redeal() {
            this.moves.push("*[0]"); // our redeal is not randomized, but keep the same format as the other redeals
            for (var t of this.tableau)
                if (t.pile.length) {
                    t.push(t.shift());
                    t.top().face = up; // bottom card might have been face down
                }
            this.redraw();
    }

    fix_replay_move(moves) {
            // interpret the *[__random_seed] notation--reset the random seed and shuffle. Our random seed is always zero since our redeal is not random, so just ignore it.
            return moves.replace(/^\*\[(\d+)\]/, function(m, r) { this.shuffle(); return "" }.bind(this));
    }

    is_complete() {
            for (var f of this.foundation)
                if (f.pile.length != 13)
                    return NOT_COMPLETE;
            return WON;
    }

    score() {
            return this.count_cards_in(this.foundation)-8;
    }


    layout = grid([void 0,      void 0,     "tableau0", "tableau1", "tableau2",    "tableau3",    "tableau4",    "tableau5",    "tableau6",   "tableau7"],
                  [void 0,      "tableau8", void 0,     void 0,     void 0,        void 0,        void 0,        void 0,        void 0,       void 0,     "tableau9"],
                  ["tableau10", void 0,     void 0,     void 0,     "foundation0", "foundation1", "foundation2", "foundation3", void 0,       void 0,     void 0,       "tableau11"],
                  ["tableau12", void 0,     void 0,     void 0,     "foundation4", "foundation5", "foundation6", "foundation7", void 0,       void 0,     void 0,       "tableau13"],
                  ["tableau14", void 0,     void 0,     void 0,     void 0,        void 0,        void 0,        void 0,        void 0,       void 0,     void 0,       "tableau15"]);
}

module.exports = solitaire.crescent;
// Copyright © 2019 David Caldwell <david@porkrind.org> All rights reserved.

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile,
                                in_suit_order=piles.in_suit_order, in_suit_wrap_order=piles.in_suit_wrap_order,
                                king=piles.king, ace=piles.ace,
                                up=piles.up, down=piles.down;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var options = require('./options'), option_def=options.option_def;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE, GAME_OVER=seed_game.GAME_OVER;
var prnt = require('./print'), sprintf=prnt.sprintf;

solitaire.crescent = class extends pile_game {
    constructor() {
        super();
        this.pile_game_init(...arguments);
        this.decks = 2;
        this.foundation = [...Array(8).keys()].map(i => new this.foundation_pile("foundation"+i, this, i<4 ? down : up));
        this.tableau = [...Array(16).keys()].map(i => new this.tableau_pile("tableau"+i, this));
    }
    valid_options = { redeals: option_def("number", 3, "Number of redeals allowed"),
                      undo:  option_def("boolean", true, "Allow undo past a redeal") };

    foundation_pile = class extends pile {
            constructor(div,game,dir) {
                super(div,game);
                this.dir=dir;
            }
        accept_stacks = false;
        accept(card) { return (this.dir == up   && in_suit_order(this.top(), card) ||
                               this.dir == down && in_suit_order(card, this.top())) ? 10 : 0; }
        xoffset = 0;
        yoffset = 0;
        can_drag(index) { return index != 0 && index == this.top_index(); }
    }

    tableau_pile = class extends pile {
        splice = pile.prototype.splice_and_turn_over;
        accept(card) { return this.pile.length && (in_suit_wrap_order(this.top(), card) ||
                                                   in_suit_wrap_order(card, this.top())) ? 4 : 0; }
        can_drag(index) { return index == this.top_index(); }
        xoffset = .5/90;
        yoffset = .5/131;
    }

    deal(deck) {
            this.update_redeals(this.options.redeals);
            var t=0;
            for (var c of deck) {
                if      (c.rank == king && this.foundation[  c.suit].pile.length == 0)
                    this.foundation[c.suit].push(c);
                else if (c.rank == ace  && this.foundation[4+c.suit].pile.length == 0)
                    this.foundation[4+c.suit].push(c);
                else
                    this.tableau[t++ % this.tableau.length].push(c);
            }
            for (let f of this.foundation)
                f.top().face = up;
            for (let t of this.tableau)
                t.top().face = up;

    }

    get_state() {
            var state = pile_game.prototype.get_state.call(this);
            state.redeals = this.redeals;
            return state;
    }

    set_state(old, noupdate) {
            pile_game.prototype.set_state.call(this, old, noupdate);
            this.update_redeals(old.redeals);
    }

    update_redeals(redeals) {
            this.shuffle_button.text(sprintf("Redeal (%d)", this.redeals = redeals));
            this.shuffle_button.enable(this.redeals > 0);
    }

    shuffle() {
            if (this.redeals <= 0)
                return;
            if (!this.options.undo)
                this.clear_state(); // disallow undo through a redeal
            else
                this.push_state(); // support undoing redeals
            this.update_redeals(this.redeals - 1);
            this.redeal();
    }

    redeal() {
            this.moves.push("*[0]"); // our redeal is not randomized, but keep the same format as the other redeals
            for (var t of this.tableau)
                if (t.pile.length) {
                    t.push(t.shift());
                    t.top().face = up; // bottom card might have been face down
                }
            this.redraw();
    }

    fix_replay_move(moves) {
            // interpret the *[__random_seed] notation--reset the random seed and shuffle. Our random seed is always zero since our redeal is not random, so just ignore it.
            return moves.replace(/^\*\[(\d+)\]/, function(m, r) { this.shuffle(); return "" }.bind(this));
    }

    is_complete() {
            for (var f of this.foundation)
                if (f.pile.length != 13)
                    return NOT_COMPLETE;
            return WON;
    }

    score() {
            return this.count_cards_in(this.foundation)-8;
    }


    layout = grid([void 0,      void 0,     "tableau0", "tableau1", "tableau2",    "tableau3",    "tableau4",    "tableau5",    "tableau6",   "tableau7"],
                  [void 0,      "tableau8", void 0,     void 0,     void 0,        void 0,        void 0,        void 0,        void 0,       void 0,     "tableau9"],
                  ["tableau10", void 0,     void 0,     void 0,     "foundation0", "foundation1", "foundation2", "foundation3", void 0,       void 0,     void 0,       "tableau11"],
                  ["tableau12", void 0,     void 0,     void 0,     "foundation4", "foundation5", "foundation6", "foundation7", void 0,       void 0,     void 0,       "tableau13"],
                  ["tableau14", void 0,     void 0,     void 0,     void 0,        void 0,        void 0,        void 0,        void 0,       void 0,     void 0,       "tableau15"]);
}

module.exports = solitaire.crescent;
